import React, { ReactNode, useState } from 'react'
import { TransferMasterPayload } from '../../types/mf-execution.types'
import {
  OTPVerificationState,
  OTPVerificationHandlers,
  OTPVerificationFailedCase as OTPFailedCase
} from '../../types/otp.types'
import { TransferContext } from '../contexts/TransferContext'

interface TransferProviderProps {
  children: ReactNode
}

const TransferProvider: React.FC<TransferProviderProps> = ({ children }) => {
  const [isTransferOTPVerified, setIsTransferOTPVerified] = useState(false)
  const [transferMasterPayload, setTransferMasterPayload] = useState<TransferMasterPayload>({
    transfer: null
  })

  // OTP Verification State
  const [isOTPVerificationLoading, setIsOTPVerificationLoading] = useState(false)
  const [isOTPVerificationLimitExceeded, setIsOTPVerificationLimitExceeded] = useState(false)
  const [OTPVerificationFailedCase, setOTPVerificationFailedCase] = useState<OTPFailedCase | null>(null)

  const handleTransferMasterPayload = (payload: TransferMasterPayload) => {
    setTransferMasterPayload(payload)
  }

  const handleTransferOTPVerification = async (otp: string) => {
    console.log('Transfer OTP verification:', otp)
    setIsOTPVerificationLoading(true)

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000))

      // For demo purposes, assume OTP is valid if it's 6 digits
      if (otp.length === 6 && /^\d{6}$/.test(otp)) {
        setIsTransferOTPVerified(true)
        setOTPVerificationFailedCase(null)
        console.log('Transfer OTP verified successfully')
      } else {
        setOTPVerificationFailedCase(OTPFailedCase.INVALID_OTP)
        console.log('Transfer OTP verification failed')
      }
    } catch (error) {
      setOTPVerificationFailedCase(OTPFailedCase.OTP_VERIFICATION_FAILED)
      console.error('Transfer OTP verification error:', error)
    } finally {
      setIsOTPVerificationLoading(false)
    }
  }

  const handleTransferResendOTP = () => {
    console.log('Transfer OTP resend requested')
    setIsOTPVerificationLimitExceeded(false)
    setOTPVerificationFailedCase(null)
    // Simulate API call to resend OTP
  }

  const otpVerificationState: OTPVerificationState = {
    isOTPVerified: isTransferOTPVerified,
    isOTPVerificationLoading,
    isOTPVerificationLimitExceeded,
    OTPVerificationFailedCase
  }

  const otpVerificationHandlers: OTPVerificationHandlers = {
    handleOTPVerification: handleTransferOTPVerification,
    handleResendOTP: handleTransferResendOTP
  }

  return (
    <TransferContext.Provider
      value={{
        transferMasterPayload,
        handleTransferMasterPayload,
        isTransferOTPVerified,
        handleTransferOTPVerification,
        otpVerificationState,
        otpVerificationHandlers
      }}
    >
      {children}
    </TransferContext.Provider>
  )
}

export default TransferProvider
